module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('mu-content-block', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "value": _vm.activeUI,
      "autoWidth": ""
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "Muse-UI",
      "value": "Muse-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "Mint-UI",
      "value": "Mint-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "iView-UI",
      "value": "iView-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "Element-UI",
      "value": "Element-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "通用",
      "value": "Common"
    }
  })], 1), _vm._v(" "), _c('mu-sub-header', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("- 组件")])], 1), _vm._v(" "), (_vm.activeUI === 'Muse-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "App Bar"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('appbar')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Grid"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('shanGe')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Text Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('textField')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Flat Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('FlatButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Raised Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('RaisedButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iconButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('icon')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Floating Action Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('floatingActionButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Avatar"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('avatar')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Chip"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('chip')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Card Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('cardHeader')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Sub Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('subHeader')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "List"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('list')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "List Item"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('listItem')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Table"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('grid')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Date Picker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('datePicker')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Time Picker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('timePicker')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Badge"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('badge')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Bottom Nav"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('navigation')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Tabs"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('tab')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Breadcrumb"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('breadcrumb')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Checkbox"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('checkBox')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Radio"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('radio')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Switch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('swit')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Select Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('selectField')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Paper"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('paper')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Pagination"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('pagination')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Slider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('slider')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Divider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('divider')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Linear Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('linearProgress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Circular Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('circularProgress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Card"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('card')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Mint-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "Header"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-button', {
    attrs: {
      "type": "default"
    }
  }, [_vm._v("Button")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Swipe"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mint-swipe')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Range"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-range')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mint-progress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Cell"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-cell', {
    attrs: {
      "title": "Cell",
      "value": "..."
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Switch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-switch', [_vm._v("Switch")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-field', {
    attrs: {
      "label": "Field",
      "placeholder": "placeholder"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Badge"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Badge")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'iView-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list iview-ui"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Row"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-row')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("Button")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "ButtonGroup"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-button-group')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Icon', {
    attrs: {
      "type": "happy-outline",
      "size": 28
    }
  }), _vm._v(" icon\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Input"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Input"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Radio"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Radio', [_vm._v("Radio")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "RadioGroup"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-radio-group')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Checkbox"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Checkbox', [_vm._v("Checkbox")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "iSwitch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('i-switch')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Select"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-select')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Slider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_vm._v("\n                Slider\n                "), _c('Slider', {
    staticStyle: {
      "width": "75%",
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "value": 50
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "DatePicker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Date-picker', {
    attrs: {
      "size": "large",
      "type": "date",
      "placeholder": "Date Picker"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "TimePicker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Time-picker', {
    attrs: {
      "size": "large",
      "type": "time",
      "placeholder": "Time Picker"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "InputNumber"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Input-number', {
    attrs: {
      "max": 10,
      "min": 1
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Rate"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Rate', {
    attrs: {
      "value": 5
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Form"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-form')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Element-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  })]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Common') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Text"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "value": "text_fields"
    }
  }), _vm._v(" 文本\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "A"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "value": "link"
    }
  }), _vm._v(" 链接\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Img"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "image"
    }
  }), _vm._v(" 图片\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Br"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "keyboard_return"
    }
  }), _vm._v(" 换行\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Div"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "check_box_outline_blank"
    }
  }), _vm._v(" div\n            ")], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d23758","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components.vue
// module id = 542
// module chunks = 1